import { formatCurrency, formatNumber, getDateFormat } from "utils/utils";
import { rolesEnum, tripDutyTypeEnum } from "utils/enumObj";
import Office from "assets/images/OfficeGrey.svg";
import Clock from "assets/images/Clock.svg";
import Calendar from "assets/images/Calendar.svg";
import Taxi from "assets/images/Taxi.png";
import WaterBottle from "assets/images/WaterBottle.svg";
import Wifi from "assets/images/Wifi.svg";
import Snack from "assets/images/Snack.svg";
import Charger from "assets/images/Charger.svg";
import NewsPaper from "assets/images/NewsPaper.svg";
import completeTrip from "assets/images/completedTrip.svg";
import onGoing from "assets/images/onGoing.svg";
import cancelled from "assets/images/cancelledTrip.svg";
import booked from "assets/images/bookedTrip.svg";

export const filterData = [
  {
    id: 1,
    primaryText: "Status",
    subItems: [
      { value: "booked", list: "Booked", key: "Status" },
      { value: "alloted", list: "Alloted", key: "Status" },
      { value: "dispatched", list: "Dispatched", key: "Status" },
      { value: "onGoing", list: "Ongoing", key: "Status" },
      { value: "completed", list: "Completed", key: "Status" },
      { value: "cancelled", list: "Cancelled", key: "Status" },
      { value: "billed", list: "Billed", key: "Status" },
    ],
  },
];

export const filterHistoryData = [
  {
    id: 1,
    primaryText: "Status",
    subItems: [
      { value: "completed", list: "Completed" },
      { value: "cancelled", list: "Cancelled" },
    ],
  },
];

//form data
export const bookingByForm = () => {
  return {
    bookingCompany: [
      {
        textField: true,
        gridSize: 4,
        placeholder: "Enter Name",
        type: "text",
        name: "bookedByName",
        label: "Booked by Name",
        fieldDisabled: true,
      },
      {
        textField: true,
        gridSize: 4,
        placeholder: "9999999999",
        maxLength: 10,
        countrycode: true,
        type: "number",
        name: "bookedByNumber",
        label: "Booked by Phone Number",
        fieldDisabled: true,
      },
      {
        textField: true,
        gridSize: 4,
        placeholder: "Enter Email ID",
        type: "email",
        name: "bookedByEmail",
        label: "Booked by Email ID",
        fieldDisabled: true,
      },
      {
        dashedBorder: "dashedBorder",
        border: "dashed",
      },
    ],
  };
};

export const bookingForm = (
  dutyTypeOption,
  carOption,
  companyEmployeelist,
  selectedCompanyDetails,
  edit,
  cityOption,
  userProfile,
  role,
  employeelist,
  employeeCode,
  extensionMode = false,
) => {
  const costCenterConfig =
    selectedCompanyDetails?.additionalInfo?.costCenterConfig;
  const isCostCenterMandatory = costCenterConfig?.visible
    ? costCenterConfig?.mandatory || false
    : false;
  const costCenterLabel = costCenterConfig?.label || "Cost Center";

  // Helper function to determine if a field should be disabled in extension mode
  const getFieldDisabled = (fieldName) => {
    if (!extensionMode) return edit;
    // In extension mode, only pickUp and endDateTime are editable
    const editableFields = [
      "pickUp",
      "landMark",
      "endDateTime",
      "multiDayBooking",
    ];
    return !editableFields.includes(fieldName);
  };

  return {
    travellerDetails: [
      !edit && {
        radio: true,
        required: true,
        name: "travellerType",
        values:
          role === "3"
            ? [
                {
                  value: "existingTraveller",
                  label: "Existing Traveler",
                },
              ]
            : [
                {
                  value: "newTraveller",
                  label: "New User",
                },
                {
                  value: "existingTraveller",
                  label: "Existing User",
                },
                {
                  value: "guestTraveller",
                  label: "Guest Traveller",
                },
              ],
      },
      {
        autoComplete: true,
        customSearch: true,
        required: true,
        gridSize: 4,
        placeholder: "Enter Email ID",
        type: "email",
        name: "employeeEmail",
        label: "Email ID",
        optionData:
          role === "3"
            ? employeelist
            : companyEmployeelist
              ? companyEmployeelist
              : [],
        fieldDisabled: getFieldDisabled("employeeEmail"),
      },
      {
        textField: true,
        required: true,
        gridSize: 4,
        placeholder: " Enter Name",
        type: "text",
        name: "employeeName",
        label: "Name",
        star: "*",
        fieldDisabled: getFieldDisabled("employeeName"),
      },
      {
        textField: true,
        required: true,
        gridSize: 4,
        placeholder: "Enter your Phone Number",
        countrycode: true,
        type: "number",
        name: "employeePhoneNumber",
        label: "Phone Number",
        fieldDisabled: getFieldDisabled("employeePhoneNumber"),
      },
      ((edit && employeeCode?.length > 0) || !edit) && {
        textField: true,
        required: true,
        gridSize: 4,
        placeholder: "Enter Employee ID",
        type: "text",
        name: "employeeCode",
        label: "Employee ID",
        fieldDisabled: getFieldDisabled("employeeCode"),
      },
      {
        textField: true,
        required: true,
        gridSize: 4,
        placeholder: "Enter Department/ Project Code/ Cost Code",
        type: "text",
        name: "departmentCode",
        label: "Department/ Project Code/ Cost Code",
        fieldDisabled: getFieldDisabled("departmentCode"),
      },
      {
        textField: true,
        required: true,
        star: "*",
        gridSize: 4,
        placeholder: "Enter Branch Name",
        type: "string",
        name: "employeeBranch",
        label: "Branch",
        fieldDisabled: true,
      },
      {
        textField: true,
        gridSize: 4,
        required: false,
        placeholder: "Enter Travel Request No.",
        type: "text",
        name: "travelRequestNumber",
        label: "Travel Request No.",
        fieldDisabled: getFieldDisabled("travelRequestNumber"),
      },
      !edit && {
        radio: true,
        required: true,
        gridSize: 8,
        label: "Billing Mode",
        name: "billingTypeAccess",
        // Default traveller type is "existingTraveller", so it starts disabled;
        // handleInput's travellerType branch re-enables it for new/guest travellers.
        fieldDisabled: true,
        values: [
          { value: 1, label: "Bill to Self" },
          { value: 2, label: "Bill to Company" },
          // { value: 3, label: "Both" },
        ],
      },
      !edit &&
        costCenterConfig?.visible && {
          textField: true,
          gridSize: 4,
          required: isCostCenterMandatory,
          star: isCostCenterMandatory ? "*" : "",
          placeholder: `Enter ${costCenterLabel}`,
          type: "text",
          name: "costCenter",
          label: costCenterLabel,
          showWhenEquals: { field: "billingTypeAccess", value: 2 },
        },
      parseInt(userProfile?.role) !== rolesEnum?.employee && {
        checkbox: true,
        gridSize: 12,
        name: "vipCheckbox",
        subItems: [
          {
            id: "1",
            name: "isVip",
            checkboxLablel: "VIP",
          },
        ],
        fieldDisabled: getFieldDisabled("vipCheckbox"),
      },
      {
        dashedBorder: "dashedBorder",
        border: "dashed",
      },
    ],
    dutyAndVehicle: [
      {
        reservationAutoComplete: true,
        gridSize: 6,
        required: true,
        star: "*",
        placeholder: "Choose your City",
        name: "location",
        label: "City",
        optionData: cityOption || [],
        fieldDisabled: getFieldDisabled("location"),
      },
      {
        reservationAutoComplete: true,
        required: true,
        gridSize: 6,
        placeholder: "Choose your Duty Type",
        name: "dutyTypeId",
        label: "Duty Type",
        star: "*",
        optionData: dutyTypeOption || [],
        fieldDisabled: getFieldDisabled("dutyTypeId"),
      },
      // NEW: show toggle next to Duty Type when Rental is selected
      {
        switch: true,
        name: "multiDayBooking",
        required: false,
        gridSize: 6,
        showForDutyTypes: ["Rental"], // renders only when dutyType is Rental
        subItems: [
          {
            id: "multiDayBooking",
            name: "multiDayBooking",
            checkboxLablel: "Multi-day booking",
          },
        ],
      },
      {
        reservationAutoComplete: true,
        required: true,
        gridSize: 6,
        placeholder: "Choose your Vehicle Group",
        name: "vehicleCategoryId",
        label: "Vehicle Category",
        star: "*",
        optionData: carOption || [],
        fieldDisabled: getFieldDisabled("vehicleCategoryId"),
      },
      {
        textField: true,
        gridSize: 6,
        required: true,
        placeholder: "Enter No. of Traveler",
        type: "number",
        name: "noOfTravelers",
        label: "No. of Traveler",
        fieldDisabled: getFieldDisabled("noOfTravelers"),
      },
      {
        guestDetails: true, // New field type
        gridSize: 12,
        name: "guestDetails",
        label: "Guest Details",
        conditionalField: "noOfTravelers",
      },
      {
        checkbox: true,
        name: "needPlacard",
        required: false,
        gridSize: 12,
        subItems: [
          {
            id: "1",
            name: "needPlacard",
            checkboxLablel: "Need Placard",
          },
        ],
      },
      {
        textField: true,
        gridSize: 12,
        multiline: true,
        rows: 2,
        placeholder: "Enter Placard Text (25 characters per line)",
        type: "text",
        name: "placardText",
        label: "Placard Text",
        maxLength: 50,
        dependentField: "needPlacard",
        validation: {
          validate: (value) => {
            if (!value) return true;
            const lines = value.split("\n");
            return (
              !lines.some((line) => line.length > 25) ||
              "Maximum 25 characters per line allowed"
            );
          },
        },
      },
      {
        dashedBorder: "dashedBorder",
        border: "dashed",
      },
    ],
    tripDetails: [
      {
        dashedBorder: "dashedBorder",
        border: "dashed",
      },
    ],
    tripNote: [
      {
        textField: true,
        gridSize: 12,
        multiline: true,
        placeholder: "Add Special Instruction",
        type: "text",
        name: "note",
        fieldDisabled: getFieldDisabled("note"),
      },
      {
        dashedBorder: "dashedBorder",
        border: "dashed",
      },
    ],
    billingType: [
      billingDetails(
        selectedCompanyDetails?.Contracts?.[0]?.billingType,
        extensionMode ? true : edit,
        extensionMode,
        selectedCompanyDetails?.additionalInfo?.billingLabelOverrides,
      ),
    ],
  };
};

export const billingDetails = (
  billingType,
  isEdit,
  extensionMode = false,
  billingLabelOverrides,
) => {
  const billToSelfLabel = billingLabelOverrides?.billToSelf || "Bill to Self";

  const billToCompanyLabel =
    billingLabelOverrides?.billToCompany || "Bill to Company";

  const handleBillingType = (billingType) => {
    switch (Number(billingType)) {
      case 1:
        return [
          {
            value: "billToIndividual",
            label: billToSelfLabel,
            // label: "Bill to Credit Card",
          },
        ];
      case 2:
        return [
          {
            value: "billToCompany",
            label: billToCompanyLabel,
            // label: "Bill to company",
          },
        ];
      case 3:
        return [
          {
            value: "billToIndividual",
            // label: "Bill to Credit Card",
            label: billToSelfLabel,
          },
          {
            value: "billToCompany",
            label: billToCompanyLabel,
            // label: "Bill to company",
          },
        ];
      default:
        return "";
    }
  };

  return {
    radio: handleBillingType(billingType) && true,
    required: true,
    gridSize: 12,
    name: "billingType",
    values: handleBillingType(billingType),
    fieldDisabled: isEdit,
  };
};

//Airport Transfer form
export const toAirportForm = (terminalList, isEdit) => [
  {
    radio: true,
    required: true,
    type: "text",
    name: "airportRideType",
    values: [
      {
        value: "To-Airport",
        label: "To the Airport",
      },
      {
        value: "From-Airport",
        label: "From the Airport",
      },
    ],
    fieldDisabled: isEdit,
  },
  {
    dateTimePicker: true,
    gridSize: 6,
    required: true,
    star: "*",
    placeholder: "Enter your Trip Date",
    type: "date",
    name: "scheduledTime",
    label: "Date & Start Time",
    min: "today",
  },
  {
    google: true,
    gridSize: 6,
    required: true,
    star: "*",
    placeholder: "Enter your From Address",
    type: "text",
    name: "pickUp",
    label: "From Address",
    clearOnBlur: false,
    fieldDisabled: isEdit,
  },
  {
    google: true,
    gridSize: 6,
    required: false,
    star: "*",
    placeholder: "Enter your Landmark",
    type: "text",
    name: "landMark",
    label: "Landmark",
    clearOnBlur: true,
    fieldDisabled: isEdit,
  },
  {
    options: true,
    gridSize: 6,
    required: true,
    star: "*",
    placeholder: "Enter your To Address",
    name: "toAirportTerminal",
    label: "To Address",
    menuOptions: terminalList,
    fieldDisabled: isEdit,
  },
  {
    textField: true,
    gridSize: 6,
    placeholder: "Enter Airline Details",
    type: "text",
    name: "airlineDetails",
    label: "Airlines Details",
    fieldDisabled: isEdit,
  },
  {
    textField: true,
    required: false,
    gridSize: 6,
    type: "text",
    placeholder: "Enter Fight Details",
    name: "flightNo",
    label: "Flight No",
    fieldDisabled: isEdit,
  },
  {
    dashedBorder: "dashedBorder",
    border: "dashed",
  },
];

export const fromAirportForm = (terminalList, isEdit) => [
  {
    radio: true,
    required: true,
    type: "text",
    name: "airportRideType",
    values: [
      {
        value: "To-Airport",
        label: "To the Airport",
      },
      {
        value: "From-Airport",
        label: "From the Airport",
      },
    ],
    fieldDisabled: isEdit,
  },
  {
    dateTimePicker: true,
    gridSize: 6,
    required: true,
    star: "*",
    placeholder: "Enter your Trip Date",
    type: "date",
    name: "scheduledTime",
    label: "Date & Start Time",
    min: "today",
  },
  {
    options: true,
    gridSize: 6,
    required: true,
    star: "*",
    placeholder: "Enter your From Address",
    name: "fromAirportTerminal",
    label: "From Address",
    menuOptions: terminalList,
    fieldDisabled: isEdit,
  },
  {
    google: true,
    gridSize: 6,
    required: true,
    star: "*",
    placeholder: "Enter your To Address",
    type: "text",
    name: "drop",
    label: "To Address",
    clearOnBlur: true,
    fieldDisabled: isEdit,
  },
  {
    textField: true,
    gridSize: 6,
    placeholder: "Enter Airline Details",
    type: "text",
    name: "airlineDetails",
    label: "Airlines Details",
    fieldDisabled: isEdit,
  },
  {
    textField: true,
    required: true,
    gridSize: 6,
    type: "text",
    placeholder: "Enter Fight Details",
    name: "flightNo",
    label: "Flight No",
    fieldDisabled: isEdit,
  },
  {
    dashedBorder: "dashedBorder",
    border: "dashed",
  },
];

//Rental Form
export const RentalFields = (
  rateCardPackage,
  edit,
  extensionMode = false,
  isMultiDay = false,
) => [
  {
    options: true,
    gridSize: 6,
    required: extensionMode || isMultiDay ? false : true,
    star: "*",
    placeholder: "Choose Package Type",
    name: "package",
    label: "Package ",
    menuOptions: rateCardPackage,
    fieldDisabled: extensionMode || isMultiDay ? true : edit,
  },
  {
    google: true,
    gridSize: 6,
    required: true,
    star: "*",
    placeholder: "Enter your From Address",
    type: "text",
    name: "pickUp",
    label: "From Address",
    clearOnBlur: false,
    fieldDisabled: extensionMode ? false : edit,
  },
  {
    google: true,
    gridSize: 6,
    required: false,
    star: "*",
    placeholder: "Enter your Landmark",
    type: "text",
    name: "landMark",
    label: "Landmark",
    clearOnBlur: true,
    fieldDisabled: extensionMode ? false : edit,
  },
  {
    google: true,
    gridSize: 6,
    placeholder: "Enter your To Address",
    type: "text",
    name: "drop",
    label: "To Address",
    clearOnBlur: true,
    fieldDisabled: extensionMode ? true : edit,
  },
  {
    dateTimePicker: true,
    gridSize: 6,
    required: true,
    star: "*",
    placeholder: "Enter your Trip Date",
    type: "date",
    name: "scheduledTime",
    label: "Date & Start Time",
    min: "today",
    fieldDisabled: extensionMode ? true : false,
  },
  // NEW: End Date & Time shown only when multiDayBooking is selected
  {
    dateTimePicker: true,
    gridSize: 6,
    required: true,
    star: "*",
    placeholder: "Enter your End Date & Time",
    type: "date",
    name: "endDateTime",
    label: "End Date & Time",
    min: "scheduledTime", // Min date is dynamically set to scheduledTime in CommonDateTimePicker
    dependentField: "multiDayBooking",
    fieldDisabled: extensionMode ? false : false,
    validation: {
      validate: (value, formValues) => {
        // Check if endDateTime is provided
        if (!value) {
          return "End date and time is required for multi-day booking";
        }

        // Get start date from scheduledTime
        const startDate = formValues?.scheduledTime;
        if (!startDate) {
          return "Please select start date first";
        }

        // Convert to Date objects for comparison
        const startDateTime = startDate?.["$d"] || new Date(startDate);
        const endDateTimeObj = value?.["$d"] || new Date(value);

        // // Calculate difference in hours
        // const timeDifferenceInMs = endDateTimeObj - startDateTime;
        // const timeDifferenceInHours = timeDifferenceInMs / (1000 * 60 * 60);

        // // Minimum 48 hours (2 days) required
        // const minimumHours = 48;

        // if (timeDifferenceInHours < minimumHours) {
        //   return 'End date and time must be at least 2 days from the start date and time';
        // }

        return true;
      },
    },
  },
  {
    dashedBorder: "dashedBorder",
    border: "dashed",
  },
];

//Outstation Form
export const outstationFields = (edit) => [
  {
    google: true,
    gridSize: 6,
    required: true,
    star: "*",
    placeholder: "Enter your From Address",
    type: "text",
    name: "pickUp",
    label: "From Address",
    clearOnBlur: false,
    fieldDisabled: edit,
  },
  {
    google: true,
    gridSize: 6,
    required: false,
    star: "*",
    placeholder: "Enter your Landmark",
    type: "text",
    name: "landMark",
    label: "Landmark",
    clearOnBlur: true,
    fieldDisabled: edit,
  },
  {
    google: true,
    gridSize: 6,
    required: true,
    star: "*",
    placeholder: "Enter your To Address",
    type: "text",
    name: "drop",
    label: "To Address",
    clearOnBlur: true,
    fieldDisabled: edit,
  },
  {
    dateTimePicker: true,
    gridSize: 6,
    required: true,
    star: "*",
    placeholder: "Enter your Trip Date",
    type: "date",
    name: "scheduledTime",
    label: "Start Date & Time ",
    min: "today",
  },
  {
    dateTimePicker: true,
    gridSize: 6,
    required: true,
    star: "*",
    placeholder: "Enter your Trip Date",
    type: "date",
    name: "returnDate",
    label: "Return Date & Time",
    min: "today",
  },
  {
    dashedBorder: "dashedBorder",
    border: "dashed",
  },
];

//adding employee form
export const addingEmployeeForm = (branchOption, approvalStatusOptions) => {
  return {
    "": [
      {
        textField: true,
        gridSize: 4,
        required: true,
        star: "*",
        placeholder: "Enter Email Id",
        type: "email",
        name: "companyEmployeeEmail",
        label: "Email ID",
      },
      {
        textField: true,
        gridSize: 4,
        placeholder: "Enter Name",
        required: true,
        type: "text",
        name: "name",
        label: "Name",
        star: "*",
      },
      {
        textField: true,
        gridSize: 4,
        placeholder: "9999999999",
        maxLength: 10,
        required: true,
        countrycode: true,
        type: "number",
        name: "phoneNumber",
        label: "Phone Number",
        star: "*",
      },
      {
        textField: true,
        gridSize: 4,
        // required: true,
        // star: "*",
        placeholder: "Enter Employee Id",
        type: "text",
        name: "employeeId",
        label: "Employee ID",
      },
      {
        textField: true,
        gridSize: 4,
        // required: true,
        // star: "*",
        placeholder: "Enter Department/ Project Code/ Cost Code",
        type: "text",
        name: "code",
        label: "Department/ Project Code/ Cost Code",
      },
      {
        options: true,
        required: true,
        gridSize: 4,
        placeholder: "Select Role",
        type: "text",
        name: "role",
        label: "Role",
        star: "*",
        menuOptions: [
          {
            label: "Admin",
            value: 2,
          },
          {
            label: "Employee",
            value: 3,
          },
          {
            label: "Finance",
            value: 4,
          },
        ],
      },
      {
        options: true,
        gridSize: 4,
        required: true,
        star: "*",
        placeholder: "Choose your branch",
        type: "text",
        name: "branchName",
        label: "Branch",
        menuOptions: branchOption,
      },
      {
        radio: true,
        required: true,
        gridSize: 6,
        label: "Billing Mode",
        name: "billingTypeAccess",
        values: [
          { value: 1, label: "Bill to Self" },
          { value: 2, label: "Bill to Company" },
          { value: 3, label: "Both" },
        ],
      },
      {
        options: true,
        required: true,
        gridSize: 4,
        placeholder: "Select Approval Status",
        type: "text",
        name: "approvalStatus",
        label: "Approval Status",
        star: "*",
        menuOptions:
          approvalStatusOptions.length > 0
            ? approvalStatusOptions
            : [
                { label: "Pending", value: "Pending" },
                { label: "Approved", value: "Approved" },
                { label: "Rejected", value: "Rejected" },
              ],
      },
      {
        gridSize: 4,
      },
    ],
  };
};

export const bookingTime = (reservationDetails, details) => {
  return [
    {
      type: "calendar",
      img: Calendar,
      title: getDateFormat(reservationDetails?.scheduledTime, "weekDay"),
    },
    {
      type: "time",
      img: Clock,
      title: getDateFormat(reservationDetails?.scheduledTime, "time"),
    },
    {
      type: "office",
      img: Office,
      title: reservationDetails?.companyName,
    },
    {
      type: "booked",
      img: Taxi,
      title: reservationDetails?.status,
    },
  ];
};

export const facilitesProviding = [
  {
    img: Wifi,
    title: "Wi-Fi",
  },
  {
    type: "Water",
    img: WaterBottle,
    title: "Water Bottle",
  },
  {
    type: "Snack",
    img: Snack,
    title: "Gloify",
  },
  {
    title: "Charger",
    img: Charger,
  },
  {
    title: "News Paper",
    img: NewsPaper,
  },
];

export const bookingDetailsData = (reservationDetails, details) => {
  const additionalDetails = [];
  const totalTripPrice =
    Number(reservationDetails?.Payments?.[0]?.tripPrice) +
    Number(reservationDetails?.driverAllowance) +
    Number(reservationDetails?.nightAllowance);

  if (reservationDetails?.bookingProcess === "others") {
    additionalDetails.push({
      title: "Booked By Name",
      data: reservationDetails?.TripBookedBy?.name,
    });

    additionalDetails.push({
      title: "Booked By Phone No.",
      data: `${reservationDetails?.TripBookedBy?.countryCode} ${reservationDetails?.TripBookedBy?.phoneNumber || reservationDetails?.TripBookedBy?.mobile || "NA"}`,
    });
  }

  return [
    ...additionalDetails,
    {
      title: "Passenger Name",
      data: reservationDetails?.customerName,
      isVip: reservationDetails?.isVip && reservationDetails?.isVip,
    },
    {
      title: "City",
      data: reservationDetails?.ServiceCity?.name || "NA",
    },
    {
      title: "Email ID",
      data: reservationDetails?.customerEmail,
    },
    {
      title: "Phone. No",
      data: `${reservationDetails?.Employee?.countryCode} ${
        reservationDetails?.customerPhone || "NA"
      }`,
    },
    {
      title: reservationDetails?.DriverProfile && "Driver Name",
      data:
        reservationDetails?.DriverProfile &&
        reservationDetails?.DriverProfile?.driverName,
    },
    {
      title: reservationDetails?.DriverProfile && "Driver Phone No.",
      data:
        reservationDetails?.DriverProfile &&
        reservationDetails?.DriverProfile?.mobile,
    },
    {
      title: reservationDetails?.DriverProfile && "Vehicle No.",
      data:
        reservationDetails?.DriverProfile &&
        reservationDetails?.DriverProfile?.Vehicle?.regNumber,
    },
    {
      title: "Vehicle Category",
      data:
        reservationDetails?.status?.toLowerCase() !== ("booked" || "cancelled")
          ? reservationDetails?.DriverProfile?.Vehicle?.carType
          : reservationDetails?.MasterCarType?.carType || "NA",
    },
    {
      title: "Duty Type",
      data: reservationDetails?.dutyTypeName,
    },
    {
      title: reservationDetails?.costCenter && "Cost Center",
      data: reservationDetails?.costCenter,
    },
    {
      title: reservationDetails?.DriverProfile && "Special Instruction",
      data: reservationDetails?.note,
      status: reservationDetails?.status,
    },
    {
      title:
        reservationDetails?.status?.toLowerCase() === "completed" && "Total km",
      data: `${formatNumber(reservationDetails?.actualDistance)}`,
    },
    {
      title:
        reservationDetails?.status?.toLowerCase() === "completed" &&
        "Drop Time",
      data: getDateFormat(details?.tripEndTime, "time"),
    },
    {
      title:
        parseInt(reservationDetails?.type) ===
          tripDutyTypeEnum.airpotTransfer && "Flight No",
      data: details?.flightNo,
    },
    {
      title: "Rep. Address",
      data: reservationDetails?.sourceAddress,
    },
    {
      title: reservationDetails?.sourceLandMarkAddress && "Landmark",
      data: reservationDetails?.sourceLandMarkAddress,
    },
    {
      title: "Drop Address",
      data: details?.tripAddress || details?.destinationAddress,
    },
    {
      title: !reservationDetails?.DriverProfile && "Special Instruction",
      data: reservationDetails?.note,
    },
    {
      title:
        reservationDetails?.status?.toLowerCase() === "completed" &&
        "Toll & Parking Charges",
      data: `₹ ${formatCurrency(reservationDetails?.tollAndParkingCharges)}`,
      textType: "textBold",
    },
    {
      title:
        reservationDetails?.status?.toLowerCase() === "completed" &&
        "Interstate Tax",
      data: `₹ ${formatCurrency(reservationDetails?.interstateTaxCharges)}`,
      textType: "textBold",
    },
    {
      title:
        reservationDetails?.status?.toLowerCase() === "completed" &&
        "Trip Charges",
      data: `₹ ${formatCurrency(totalTripPrice)}`,
      textType: "textBold",
      exclusive: true,
    },
    {
      title:
        reservationDetails?.status?.toLowerCase() === "cancelled" &&
        "Cancellation Reason",
      data: reservationDetails?.cancellationReason || "NA",
    },
  ];
};

export const newUser = {
  textField: true,
  required: true,
  gridSize: 4,
  placeholder: "Enter Email ID",
  type: "text",
  name: "newEmployeeEmail",
  label: "Email ID",
};

export const employeeCode = {
  textField: true,
  // required: true,
  gridSize: 4,
  placeholder: "Enter Employee ID",
  type: "text",
  name: "employeeCode",
  label: "Employee ID",
};

export const existingUser = (employeeList) => {
  let obj = "";
  return (obj = {
    autoComplete: true,
    required: true,
    gridSize: 4,
    placeholder: "Enter Email ID",
    type: "email",
    name: "employeeEmail",
    label: "Email ID",
    optionData: employeeList || [],
  });
};

export const newBranch = (branchOption) => {
  let obj = "";
  return (obj = {
    options: true,
    gridSize: 4,
    required: false,
    star: "*",
    placeholder: "Choose your branch",
    type: "text",
    name: "branch",
    label: "Branch",
    menuOptions: branchOption,
  });
};

export const branchOption = (companyBranch, isEdit) => {
  const newBranch = (companyBranch) => {
    return {
      options: true,
      gridSize: 4,
      required: true,
      star: "*",
      placeholder: "Choose your Branch",
      name: "newBranch",
      label: "Branch",
      menuOptions: companyBranch,
      fieldDisabled: isEdit,
    };
  };

  const existingBranch = () => {
    return {
      textField: true,
      required: true,
      star: "*",
      gridSize: 4,
      placeholder: "Enter Branch Name",
      type: "string",
      name: "employeeBranch",
      label: "Branch",
      fieldDisabled: true,
    };
  };

  return { newBranch, existingBranch };
};

//Dialog Data
export const cancelDialogMenu = [
  {
    id: "1",
    key: "cancelDuty",
    label: "Cancel",
  },
];
export const bookingFormBorder = {
  dashedBorder: "dashedBorder",
  border: "dashed",
};

export const dashboardCardData = (dashBorardUpperData) => {
  return [
    {
      id: 1,
      img: completeTrip,
      title: "Completed Trips",
      subTitle: dashBorardUpperData?.totalfinishedrides || "0",
    },
    {
      id: 2,
      img: onGoing,
      title: "Ongoing Trips",
      subTitle: dashBorardUpperData?.activerides || "0",
    },
    {
      id: 3,
      img: booked,
      title: "Booked Trips",
      subTitle: dashBorardUpperData?.upcomingRides || "0",
    },
    {
      id: 4,
      img: cancelled,
      title: "Cancelled Trips",
      subTitle: dashBorardUpperData?.canceledRides || "0",
    },
  ];
};
